import { AccErrorPage } from 'accelerator-common/lib/AccErrorPage';
import { getIsDarkTheme } from 'owa-fabric-theme';
import loc, { formatToArray } from 'owa-localize';
import { lazySignout } from 'owa-signout';
import React from 'react';
import { Link } from '@fluentui/react-components';
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import PlacesIcon from '../assets/Places.svg';
import {
    hybridspaceErrorAccessDeniedCallToAction,
    hybridspaceErrorAccessDeniedCallToActionHyperlinkText,
    hybridspaceErrorAccessDeniedSignOut,
    hybridspaceErrorAccessDeniedSubtitle,
    hybridspaceErrorAccessDeniedTitle,
} from './AccessDenied.locstring.json';
import { noAccessLabelDarkMode } from './AccessDenied.scss';

const microsoftPlacesLink = 'https://www.microsoft.com/microsoft-places';

export interface AccessDeniedProps {
    showSignOut: boolean;
}
export default function AccessDenied({ showSignOut }: AccessDeniedProps): JSX.Element {
    const detailMessageElement = React.useMemo(() => {
        return [
            <>
                {loc(hybridspaceErrorAccessDeniedSubtitle)}
                <br />
                <br />
                {formatToArray(
                    loc(hybridspaceErrorAccessDeniedCallToAction),
                    <Link
                        href={microsoftPlacesLink}
                        target="_blank"
                        data-telemetry-id="PlacesAccessDeniedLearnMoreLink"
                        className={getIsDarkTheme() ? noAccessLabelDarkMode : undefined}
                    >
                        {loc(hybridspaceErrorAccessDeniedCallToActionHyperlinkText)}
                    </Link>
                )}
            </>,
        ];
    }, []);
    return (
        <AccErrorPage
            customizedIcon={PlacesIcon}
            mainMessageResourceId={hybridspaceErrorAccessDeniedTitle}
            detailMessageResourceId={hybridspaceErrorAccessDeniedSubtitle}
            detailMessageElement={detailMessageElement}
            clickToActionMessageResourceId={
                showSignOut ? hybridspaceErrorAccessDeniedSignOut : undefined
            }
            onClickToActionClick={showSignOut ? onSignOut : undefined}
        />
    );
}

function onSignOut() {
    lazySignout.importAndExecute();
}
